import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountProductOrderUpdatePage = lazy(() => import('../views/update/AccountProductOrderUpdatePage'));

export function AccountProductOrderUpdatePageLazy() {
	return (
		<PageSuspense>
			<AccountProductOrderUpdatePage />
		</PageSuspense>
	);
}
